import dbee from '@os/dbee';

const localStorage = dbee('finance-components');

export default localStorage;
export const recentStorage = localStorage.ns('stock-recently-viewed');



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/lib/storage.js